import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=2f16cec6&scoped=true&"
import script from "./file-preview.vue?vue&type=script&lang=js&"
export * from "./file-preview.vue?vue&type=script&lang=js&"
import style0 from "./file-preview.vue?vue&type=style&index=0&id=2f16cec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16cec6",
  null
  
)

export default component.exports